import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import {MatSnackBar} from '@angular/material/snack-bar';
 
@Component({
  selector: 'app-state-modal',
  templateUrl: './state-modal.component.html', 
  styleUrls: ['./state-modal.component.scss']
})
export class StateModalComponent implements OnInit {

  isLoading = true;
  Errors = null;
  titles = null;
  mode = null;
  countries = null
  data = null
  Success = null
  filterddata: any = [];
  private _searchText:string ;

  get searchText(): string {
      return this._searchText;
  }

  set searchText(value: string) {
    this._searchText = value;
    this.filterddata = this.filterdata(value)
}

filterdata(searchString: string) {
    return this.titles.filter( log =>
      log.name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1);
}


  stateForm = new FormGroup({
    name: new FormControl('', Validators.required),
    id: new FormControl(null, Validators.required),
    Country_Id: new FormControl('', Validators.required),
  });

  constructor(private modal: ModalService, private _snackBar: MatSnackBar, public auth: SettingsService) { }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      name,
      id,
      Country_Id,
    } = this.stateForm.value;
    this.auth
      .postState(
        name,
        id,
        Country_Id,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;

          if (this.data.success) {
            this.closeModal()
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            }); 
          }
          else {
            this.Errors = "Not successful, please try again"
            console.log("error")
          }
          
        },
        (resErr) => {
          this.isLoading = false; 
          this.Errors = resErr;
          console.log(resErr)
        }
      );
  }

  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {
    this.auth
      .getcountry()
      .subscribe(
        (resSuccess) => {

          this.countries = resSuccess
        },
        (resErr) => {
          this.Errors = resErr;
        }
      );
    this.auth
      .getState()
      .subscribe(
        (resSuccess) => {

          this.titles = resSuccess
          this.filterddata = this.titles
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        } 
      );
  }
  addNew() {
    this.mode = "add"
  }
  edit(title) {
    this.mode = "edit"
    this.stateForm.patchValue({
      name: title.name,
      id: title.id,
      Country_Id: title.Country_Id
    });
    console.log(this.stateForm.value)
  }

  delete(title) {
    this.auth
      .delSet("/api/geography/state/delete", title.id)
      .subscribe(
        (resSuccess) => {
          this.filterddata = this.filterddata.filter(dattum => dattum.id !== title.id)
          this._snackBar.open('Deleted Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        },
        (resErr) => {
          this._snackBar.open('Error try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
  }

}
